import { ReturnEntryHistoryState, ReturnEntryStateRoomOccupancy, ReturnEntryStateFoodBeverage, ReturnEntryStateOther, ReturnEntryStateSplitValueVehicle } from '../types/GrossReceiptReturnTypes';
import { grossReceiptTypes } from '../utility/Constants';

export function isRoomOccupancy(grossReceipt: ReturnEntryHistoryState): grossReceipt is ReturnEntryStateRoomOccupancy {
    return grossReceipt.grossReceiptTypeCode === grossReceiptTypes.roomOccupancy;
}

export function isFoodBeverage(grossReceipt: ReturnEntryHistoryState): grossReceipt is ReturnEntryStateFoodBeverage {
    return grossReceipt.grossReceiptTypeCode === grossReceiptTypes.foodBev;
}

export function isSplitValueVehicle(grossReceipt: ReturnEntryHistoryState, yearFor: number | null): grossReceipt is ReturnEntryStateSplitValueVehicle {
    return grossReceipt.grossReceiptTypeCode === grossReceiptTypes.vehicle && yearFor !== null && grossReceipt.splitVehicleUnderByYear[yearFor] !== null;
}

export function isHeavyEquipment(grossReceipt: ReturnEntryHistoryState): grossReceipt is ReturnEntryStateOther {
    return grossReceipt.grossReceiptTypeCode === grossReceiptTypes.heavyEquipment;
}

export function mustBeRoomOccupancy(grossReceiptReturn: ReturnEntryHistoryState): asserts grossReceiptReturn is ReturnEntryStateRoomOccupancy {
    if (!isRoomOccupancy(grossReceiptReturn)) {
        throw new Error("Current state type was not room occupancy, but attempting to update a room occupancy field.");
    }
}

export function mustBeFoodBeverage(grossReceiptReturn: ReturnEntryHistoryState): asserts grossReceiptReturn is ReturnEntryStateFoodBeverage {
    if (!isFoodBeverage(grossReceiptReturn)) {
        throw new Error("Current state type was not food and beverage, but attempting to update a food and beverage field.");
    }
}

export function mustBeSplitValueVehicle(grossReceiptReturn: ReturnEntryHistoryState): asserts grossReceiptReturn is ReturnEntryStateSplitValueVehicle {
    if (!isSplitValueVehicle(grossReceiptReturn, 0)) {
        throw new Error("Current state type was not vehicle with split value, but attempting to update a vehicle field with split value.");
    }
}